// import PropTypes from 'prop-types'
import { isPresent } from 'utils'

import Divider from 'components/Divider'
import Header from 'components/Header'
import RichText from 'components/RichText'
import Spacer from 'components/Spacer'
import Text from 'components/Text'

import { Excerpt, Image, Main, Meta, MetaTitle, Root } from './ArtisanCard.style'

const baseUrl = '/artisans/'

const loader = ({ src, width, quality }) => {
  return `${src}&w=${width}&q=${quality || 75}&ar=6:4&fit=crop`
}

const ArtisanCard = ({ name, imageUrl, summary, handle, location, availability }) => {
  return (
    <Root as={isPresent(handle) ? 'a' : 'div'} href={isPresent(handle) && `${baseUrl}${handle}`}>
      {isPresent(imageUrl) && <Image loader={loader} width="600" height="400" src={imageUrl} alt="" sizes="33w" />}
      <Main>
        <Header size="sm">{name}</Header>
        <Spacer y={2} />
        <Excerpt>
          <RichText html={summary} />
        </Excerpt>
        {isPresent(location) && (
          <Meta>
            <Spacer y={3} />
            <Divider />
            <Spacer y={3} />
            <MetaTitle>
              <Text weight="bold" size="sm">
                Location
              </Text>
            </MetaTitle>
            <Text>{location}</Text>
          </Meta>
        )}
        {isPresent(availability) && (
          <Meta>
            <Spacer y={3} />
            <Divider />
            <Spacer y={3} />
            <MetaTitle>
              <Text weight="bold" size="sm">
                Availability
              </Text>
            </MetaTitle>
            <Text html={availability} />
          </Meta>
        )}
      </Main>
    </Root>
  )
}

ArtisanCard.propTypes = {}

ArtisanCard.defaultProps = {}

export default ArtisanCard
